import { ATIVO_MERCADO } from "@investirapri/financa.js/lib/enums";

const ROUTES_MERCADOS = {
  contas: {
    ...ATIVO_MERCADO.CNT,
    descricao: "Contas",
    metadata: {
      description: "Contas bancárias e outros tipos de contas financeiras",
    },
  },
  poupancas: {
    ...ATIVO_MERCADO.POU,
    descricao: "Poupanças",
    metadata: {
      description:
        "Caderneta de poupança e outros investimentos de baixo risco",
    },
  },
  previdencias: {
    ...ATIVO_MERCADO.PRV,
    descricao: "Previdencias",
    metadata: { description: "Planos de previdência privada e complementar" },
  },
  fundos: {
    ...ATIVO_MERCADO.FND,
    descricao: "Fundos de Investimento",
    metadata: {
      description:
        "Fundos de investimento de diferentes categorias como: Renda Fixa, Multimercado, Ações, Cambial, FIIs (Fundos Imobiliários), ETFs e outros tipos de estratégias",
    },
  },
  "titulos-publicos": {
    ...ATIVO_MERCADO.TPU,
    descricao: "Títulos Públicos",
    metadata: { description: "Títulos públicos federais e do tesouro direto" },
  },
  "titulos-privados": {
    ...ATIVO_MERCADO.TPR,
    descricao: "Títulos Privados",
    metadata: {
      description: "Títulos de dívida privada como debêntures e CRI",
    },
  },
  "titulos-bancarios": {
    ...ATIVO_MERCADO.TBA,
    descricao: "Títulos Bancários",
    metadata: {
      description: "CDBs, RDBs e outros títulos emitidos por bancos",
    },
  },
  acoes: {
    ...ATIVO_MERCADO.ACN,
    descricao: "Ações",
    metadata: { description: "Ações de empresas listadas em bolsa" },
  },
  fgts: {
    ...ATIVO_MERCADO.FGT,
    descricao: "FGTS",
    metadata: { description: "Fundo de Garantia do Tempo de Serviço" },
  },
  derivativos: {
    ...ATIVO_MERCADO.DRI,
    descricao: "Derivativos",
    metadata: { description: "Contratos futuros, opções e outros derivativos" },
  },
  criptomoedas: {
    ...ATIVO_MERCADO.CRP,
    descricao: "Criptomoedas",
    metadata: { description: "Bitcoin e outras criptomoedas" },
  },
  imoveis: {
    ...ATIVO_MERCADO.IMV,
    descricao: "Imóveis",
    metadata: { description: "Imóveis residenciais e comerciais" },
  },
  veiculos: {
    ...ATIVO_MERCADO.VEI,
    descricao: "Veículos",
    metadata: { description: "Carros, motos e outros veículos" },
  },
  cartoes: {
    ...ATIVO_MERCADO.CAR,
    descricao: "Cartões",
    metadata: { description: "Cartões de crédito e benefícios" },
  },
  "moedas-estrangeiras": {
    ...ATIVO_MERCADO.MOE,
    descricao: "Moedas Estrangeiras",
    metadata: { description: "Moedas estrangeiras e câmbio" },
  },
  agronegocios: {
    ...ATIVO_MERCADO.AGR,
    descricao: "Agronegócios",
    metadata: { description: "Investimentos no setor agrícola" },
  },
  "metais-nobres": {
    ...ATIVO_MERCADO.MTL,
    descricao: "Metais Nobres",
    metadata: { description: "Ouro, prata e outros metais preciosos" },
  },
  "pedras-preciosas": {
    ...ATIVO_MERCADO.PDR,
    descricao: "Pedras Preciosas",
    metadata: { description: "Diamantes e outras pedras preciosas" },
  },
  "obras-artes": {
    ...ATIVO_MERCADO.ART,
    descricao: "Obras de Arte",
    metadata: { description: "Obras de arte e itens colecionáveis" },
  },
  "programas-fidelidade": {
    ...ATIVO_MERCADO.FDL,
    descricao: "Programas de Fidelidade",
    metadata: { description: "Programas de milhagem e fidelidade" },
  },
  seguros: {
    ...ATIVO_MERCADO.SEG,
    descricao: "Seguros",
    metadata: { description: "Seguros de vida, auto e outros" },
  },
  "outros-bens": {
    ...ATIVO_MERCADO.BEM,
    descricao: "Outros Bens",
    metadata: { description: "Outros tipos de bens e ativos" },
  },
  contabil: {
    ...ATIVO_MERCADO.CBL,
    descricao: "Contábil",
    metadata: { description: "Lançamentos e registros contábeis" },
  },
};

export default ROUTES_MERCADOS;
